/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurchaseOrderParam
 */
export interface PurchaseOrderParam {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderParam
     */
    purchaseOrderNumber: string;
}

/**
 * Check if a given object implements the PurchaseOrderParam interface.
 */
export function instanceOfPurchaseOrderParam(value: object): value is PurchaseOrderParam {
    if (!('purchaseOrderNumber' in value) || value['purchaseOrderNumber'] === undefined) return false;
    return true;
}

export function PurchaseOrderParamFromJSON(json: any): PurchaseOrderParam {
    return PurchaseOrderParamFromJSONTyped(json, false);
}

export function PurchaseOrderParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseOrderParam {
    if (json == null) {
        return json;
    }
    return {
        
        'purchaseOrderNumber': json['purchaseOrderNumber'],
    };
}

export function PurchaseOrderParamToJSON(value?: PurchaseOrderParam | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'purchaseOrderNumber': value['purchaseOrderNumber'],
    };
}

